import { render, staticRenderFns } from "./Distance.vue?vue&type=template&id=5cda35f8&scoped=true&"
import script from "./Distance.vue?vue&type=script&lang=js&"
export * from "./Distance.vue?vue&type=script&lang=js&"
import style0 from "./Distance.vue?vue&type=style&index=0&id=5cda35f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cda35f8",
  null
  
)

export default component.exports